
const digest = '781a90439d97e9aa75c0cc64b3e2ea21ed19f5dae4e59e856acf143cfc744f0e';
const classes = {"wrapper":"_wrapper_1hwrl_1","image":"_image_1hwrl_10","content":"_content_1hwrl_16","title":"_title_1hwrl_21"};
const css = `._wrapper_1hwrl_1 {
  display: flex;
  flex-direction: row;
  gap: 15px;
  background-color: #ffffff;
  border-radius: 15px;
  padding: 16px;
  align-items: center;
}
._wrapper_1hwrl_1 ._image_1hwrl_10 {
  height: 60px;
  width: 60px;
  border-radius: 100%;
  object-fit: cover;
}
._wrapper_1hwrl_1 ._content_1hwrl_16 {
  display: flex;
  flex-direction: column;
  color: #3C3F9C;
}
._wrapper_1hwrl_1 ._content_1hwrl_16 ._title_1hwrl_21 {
  font-size: 16px;
  font-weight: 600;
  text-decoration: underline;
  word-break: break-word;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  